"use client";

import type { BotIdTags } from "@homeinstead/analytics";

import { getBotIdTagsAction } from "~www/actions/get-bot-id-tags";
import { FALLBACK_BOTID_TAGS } from "~www/lib/bot-id/bot-id-tags";

let cachedTagsPromise: Promise<BotIdTags> | null = null;

function getCachedBotIdTags(): Promise<BotIdTags> {
  cachedTagsPromise ??= getBotIdTagsAction().catch(() => {
    // Drop the rejected promise so a later call can retry after a transient
    // network / server-action failure. Resolve with fallback tags so Segment
    // page() is never gated on BotID transport errors.
    cachedTagsPromise = null;
    return FALLBACK_BOTID_TAGS;
  });
  return cachedTagsPromise;
}

function resetCachedBotIdTagsForTests(): void {
  cachedTagsPromise = null;
}

export { getCachedBotIdTags, resetCachedBotIdTagsForTests };
